import type { Preferences } from 'services/notifications/schemas';

export enum DocumentStandardPreferences {
  ANY = 'ANY',
  MINE = 'MINE',
  NEVER = 'NEVER',
}

export enum DocumentViewedSchedulePreferences {
  AFTER_VIEWED = 'AFTER_VIEWED',
  EACH_TIME_UNIQUE = 'EACH_TIME_UNIQUE',
  EACH_TIME_VIEWED = 'EACH_TIME_VIEWED',
}

export enum DocumentHasNotBeenViewedSchedulePreferences {
  ONE_DAY = 'ONE_DAY',
  ONE_WEEK = 'ONE_WEEK',
}

export enum SendNotificationSignatureSchedule {
  EACH_TIME = 'EACH_TIME',
  ONLY_AFTER = 'ONLY_AFTER',
}

export type PreferencesFormData = Preferences;

export type CreatePreferencesData = Omit<Preferences, 'userId' | 'preferenceType'>;

export type UpdatePreferencesData = Partial<Omit<Preferences, 'userId' | 'preferenceType'>> & {
  userId: string;
};
